import { signOut } from "firebase/auth";
import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom";
import auth from "../../../firebase.init";
const Header = () => {

  const [user] = useAuthState(auth);
  const handleSignOut = () => {
    signOut(auth);
  };

  return (
    <div>
      <Navbar collapseOnSelect expand="lg" bg="light" variant="light" className="text-dark fw-bold text-uppercase" >
        <Container>
          <Navbar.Brand as={Link} to="/">
            Rony Turing
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">

            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/services">Services</Nav.Link>
            </Nav>
            <Nav className="">
              <Nav.Link as={Link} to="/Blogs">Blogs</Nav.Link>
            </Nav>
            <Nav>
              <Nav.Link as={Link} to="/about">
                About Me
              </Nav.Link>
            </Nav>
            <Nav>
              {user ?
                <button onClick={handleSignOut}>Sign Out</button>
                :
                <Nav.Link eventKey={2} as={Link} to="/login">
                  Log In
                </Nav.Link>
              }
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
